import { ApolloClient, from, HttpLink, InMemoryCache } from '@apollo/client';
import {setContext} from "@apollo/client/link/context";
import {ErrorResponse, onError} from "@apollo/client/link/error";
import {errorTracker, graphqlErrorHandler} from "./graphql-error-handler";
import { createUploadLink } from 'apollo-upload-client';
import {getToken} from "@coverright/shared/keycloak";
import { environment } from '@coverright/shared/config';

const httpLink = createUploadLink({ uri: environment.enrollGraphqlUrl })

const authLink = setContext(async (_, { headers }: any) => {

  const token = await getToken().catch(() => {});
  if (token) {
    return {
      headers: {
        authorization: token ? `Bearer ${token}` : "",
        ...headers,
      }
    };
  } else {
    return {
      headers
    };
  }
});

const elink = onError((errResponse: ErrorResponse) => {
  try {
    getToken().then(token => errorTracker(errResponse, token)).catch(() => errorTracker(errResponse));
  } catch (e) {
    errorTracker(errResponse);
  }
  if (graphqlErrorHandler) {
    graphqlErrorHandler(errResponse);
  }
});

const requestLink =
  from([
    authLink,
    elink,
    httpLink as any,
  ])
;

export const uploadClient = new ApolloClient({
  link: requestLink,
  cache: new InMemoryCache({
    addTypename: false
  })
});
